// extracted by mini-css-extract-plugin
module.exports = {"subText":"styles_subText__3NMgL"};